import { useEffect } from 'react';
import { AppProvider, useAppContext } from './context/AppContext';
import './i18n';
import { Page } from './interfaces';
import CategorySelection from './pages/CategorySelection';
import ReplyList from './pages/ReplyList';
import { initializeSegment } from './services/Segment';

const App = () => {
  useEffect(() => {
    initializeSegment();
  }, []);
  const CurrentPage = () => {
    const { page } = useAppContext();

    const pages: Record<Page, JSX.Element> = {
      CategorySelection: <CategorySelection test-id="category_selection" />,
      RepliesList: <ReplyList test-id="reply_list" />,
    };

    return <>{pages[page] || null}</>;
  };

  return (
    <AppProvider>
      <CurrentPage />
    </AppProvider>
  );
};

export default App;
